<div class="search-place-bar">
  <input
    type="text"
    [placeholder]="'browse.map.placeholder' | translate"
    [value]="(searchedPlace$ | async) ? (searchedPlace$ | async).name : ''"
    #addresstext
    autocomplete="off"
  />
  <div class="suggestions-dropdown" *ngIf="showSuggestions">
    @for (suggestion of suggestions; track $index) {
      <div class="suggestion-item" 
        (click)="selectPlace(suggestion)">
        {{ suggestion.display_name }}
      </div>
    }
  </div>
</div>
